import { render, staticRenderFns } from "./VistaListaComisiones.vue?vue&type=template&id=109fb9b4&scoped=true"
import script from "./VistaListaComisiones.vue?vue&type=script&lang=js"
export * from "./VistaListaComisiones.vue?vue&type=script&lang=js"
import style0 from "./VistaListaComisiones.vue?vue&type=style&index=0&id=109fb9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109fb9b4",
  null
  
)

export default component.exports